import { useEffect } from "react";
import { Link } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { FaWhatsapp, FaPhoneAlt } from "react-icons/fa";
import { IoMdMailOpen } from "react-icons/io";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import {
  BELSOFT_SUPPORT_WHATSAPP,
  useBelaChat,
} from "../../components/Bela/BelaChatContext";
import "../../components/Bela/BelAiChat.css";
import "./Support.css";

function SupportChannels() {
  const { openChatBot } = useBelaChat();

  return (
    <div className="support-channels">
      <button
        type="button"
        className="support-channel"
        data-bel-chat-launcher
        onClick={openChatBot}
      >
        <div className="support-channel-main">
          <div className="bela-image-container support-bela-avatar">
            <img src="/Bela.png" alt="Bela" width={48} height={48} />
          </div>
          <div className="support-channel-copy">
            <h3>Live chat with Bela</h3>
            <p>Ask our virtual assistant — she’ll connect you to the team.</p>
          </div>
        </div>
        <IoIosArrowForward aria-hidden />
      </button>

      <a
        className="support-channel"
        href={BELSOFT_SUPPORT_WHATSAPP}
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className="support-channel-main">
          <span className="support-channel-icon whatsapp">
            <FaWhatsapp size={22} />
          </span>
          <div className="support-channel-copy">
            <h3>WhatsApp</h3>
            <p>Chat with Belsoft Systems support on 0707 901 0708</p>
          </div>
        </div>
        <IoIosArrowForward aria-hidden />
      </a>

      <a className="support-channel" href="mailto:enquiry@belsoftsystems.com">
        <div className="support-channel-main">
          <span className="support-channel-icon email">
            <IoMdMailOpen size={22} />
          </span>
          <div className="support-channel-copy">
            <h3>Email us</h3>
            <p>enquiry@belsoftsystems.com</p>
          </div>
        </div>
        <IoIosArrowForward aria-hidden />
      </a>

      <a className="support-channel" href="tel:+2347079010708">
        <div className="support-channel-main">
          <span className="support-channel-icon phone">
            <FaPhoneAlt size={18} />
          </span>
          <div className="support-channel-copy">
            <h3>Call us</h3>
            <p>+234 707 901 0708</p>
          </div>
        </div>
        <IoIosArrowForward aria-hidden />
      </a>
    </div>
  );
}

const Support = () => {
  useEffect(() => {
    document.title = "Support | Belsoft Systems";
  }, []);

  return (
    <div className="support-page">
      <NavBar />

      <header className="support-hero">
        <div className="container">
          <div className="support-hero-body">
            <p className="support-eyebrow">We’re here to help</p>
            <h1>Support</h1>
            <p className="support-hero-lead">
              Talk to Bela, message us on WhatsApp, or reach Belsoft Systems
              directly — same team, clear answers.
            </p>
          </div>
        </div>
      </header>

      <section className="container support-section">
        <div className="support-intro">
          <h2>How can we help?</h2>
          <p>
            Choose a channel below. For the fastest response on products like
            EZA Ride, Eza, and BelPower, WhatsApp and Bela are the best places to
            start.
          </p>
        </div>

        <SupportChannels />

        <div className="support-aside">
          <h3>Office</h3>
          <p>
            Ridds Plaza Plot 740, Aguwan Anaekwe Street, Wuye Suite 046/47,
            Abuja-Nigeria
          </p>
          <div className="support-aside-links">
            <Link to="/hire-us">Hire Us</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Support;
